import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetForm as GetFormQuery,
    GetFormVariables as GetFormVariables,
    GetForm_form as Form,
} from 'nutshell-graphql-types';

import GET_FORM from '../../../graphql/queries/get-form.graphql';

export const useGetForm = (input: {
    formId?: string | null | undefined;
    formSlug?: string | null | undefined;
}): {
    form: Form | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetFormQuery, GetFormVariables>(GET_FORM, {
        variables: {
            formId: input.formId,
            formSlug: input.formSlug,
        },
        skip: !input.formId && !input.formSlug,
    });

    const form = data ? data.form : null;

    return {
        form,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
